import { useEffect } from "react";

const DEFAULT_TITLE = "AJS Luxury | Premium Skin, Hair & Body Care";
const DEFAULT_DESC = "AJS Luxury – premium skin, hair and body care from Primus and Bellecare Natural, crafted with organic oils and botanical extracts. Dermatologically tested, never on animals.";

const setMeta = (sel, attr, value) => {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    const [k, v] = sel.replace(/^meta\[|\]$/g, "").split("=");
    el.setAttribute(k, v.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const useSeo = (title, description) => {
  useEffect(() => {
    const t = title ? `${title} | AJS Luxury` : DEFAULT_TITLE;
    const d = (description || DEFAULT_DESC).replace(/\s+/g, " ").trim().slice(0, 160);
    document.title = t;
    setMeta('meta[name="description"]', "content", d);
    setMeta('meta[property="og:title"]', "content", t);
    setMeta('meta[property="og:description"]', "content", d);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = window.location.origin + window.location.pathname;
  }, [title, description]);
};
